import axios from 'axios';

export const getDropdownSubChildCategory = async () => {
    return await axios.get(`${window._HOST}admin/akun/subCategoriesChild/dropdown`, {withCredentials: true});
}

export const getAllDataTableAkunSubChildCategory = async (searchText = null, offset = 0, limit = 0, sortingCol = 0, sortingMode = 'DESC') => {
    if(searchText) {
        return await axios.get(`${window._HOST}admin/akun/subCategoriesChild/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    } else {
        return await axios.get(`${window._HOST}admin/akun/subCategoriesChild/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    }
}

export const insertNewAkunSubChildCategory = async (formData) => {
    return await axios.post(`${window._HOST}admin/akun/subCategoriesChild/`, formData, {withCredentials: true})
}

export const updateAkunSubChildCategory = async (formData, id_akun_sub_child_category) => {
    return await axios.put(`${window._HOST}admin/akun/subCategoriesChild/${id_akun_sub_child_category}`, formData, {withCredentials: true})
}

export const deleteAkunSubChildCategory = async (id_akun_sub_child_category) => {
    return await axios.delete(`${window._HOST}admin/akun/subCategoriesChild/${id_akun_sub_child_category}`, {withCredentials: true})
}